// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import URLHelpers from './shared/url_helpers';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import {
  Item2ListingPaymentPoliciesData,
} from '@reverbdotcom/commons/src/gql/graphql';
import { useExpEnabled, useUser } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isEligibleForAffirmCAD } from '@reverbdotcom/commons/src/user_context_helpers';

interface IProps {
  listing: Item2ListingPaymentPoliciesData.Fragment;
}

const PAYMENT_METHOD_TYPE_TO_ICON_SLUG = {
  direct_checkout: 'reverb-credits',
  dc_via_paypal: 'paypal',
  klarna_account: 'klarna',
};

export const ListingPaymentPoliciesFragment = gql`
  fragment Item2ListingPaymentPoliciesData on Listing {
    _id
    acceptedPaymentMethods
  }
`;

function getPaymentMethodUrl(slug) {
  if (slug === 'direct_checkout') {
    return URLHelpers.reverbPaymentsFaqPath;
  }

  if (slug === 'affirm') {
    return URLHelpers.cmsPagePath('affirm-faqs');
  }

  if (slug === 'gift_cards') {
    return '/gift-cards';
  }

  return null;
}

function getIconSlug(paymentMethodType: string) {
  const slug = PAYMENT_METHOD_TYPE_TO_ICON_SLUG[paymentMethodType];

  return slug || paymentMethodType;
}

function renderPaymentMethodLink(method) {
  if (!getPaymentMethodUrl(method)) {
    return I18n.t(`discovery.listingPaymentPolicies.${method}`);
  }

  return (
    <CoreLink to={getPaymentMethodUrl(method)} target="_blank">
      {I18n.t(`discovery.listingPaymentPolicies.${method}`)}
    </CoreLink>
  );
}

function renderPaymentMethod(slug) {
  if (slug === 'apple_pay' || slug === 'android_pay') return null;

  return (
    <li className="d-flex fx-align-center mb-1" key={slug}>
      <div className={`payment-icon payment-icon--small payment-icon--${getIconSlug(slug)}`} />
      <span className="ml-2">
        {renderPaymentMethodLink(slug)}
      </span>
    </li>
  );
}

export default function ListingPaymentPolicies({ listing }: IProps) {
  const isAffirmCADEnabled = useExpEnabled(experiments.AFFIRM_CAD);
  const user = useUser();

  if (!listing?.acceptedPaymentMethods) { return null; }

  const acceptedPaymentMethods = !isAffirmCADEnabled && isEligibleForAffirmCAD(user) ? listing?.acceptedPaymentMethods.filter((method) => method !== 'affirm') : listing?.acceptedPaymentMethods;

  return (
    <>
      <div className="size-90 mb-2">
        {I18n.t('discovery.listingPaymentPolicies.accepts')}
      </div>
      <ul className="mlr-4 size-90">
        {acceptedPaymentMethods.map(renderPaymentMethod)}
      </ul>
    </>
  );
}
